export default "__VITE_ASSET__DxlbbDva__"